import React, { useState, useEffect, useRef } from 'react';
import { functions, isEqual, omit } from 'lodash';
import config from '../../config';
import { loadGoogleMaps } from '../../utils/loadGoogleMaps';
import './Map.scss';

function Map({ options, onMount, className, onMountProps }) {
  const ref = useRef();
  const [map, setMap] = useState();

  useEffect(() => {
    loadGoogleMaps(config.googleMaps.GOOGLE_MAPS_API_KEY).then((google) => {
      const mapInstance = new google.maps.Map(ref.current, { ...options });
      setMap(mapInstance);
    });
  }, [options]);

  useEffect(() => {
    if (map && typeof onMount === 'function') {
      const bounds = new window.google.maps.LatLngBounds();
      onMountProps.forEach(p => {
        bounds.extend(new window.google.maps.LatLng(p.coords.lat, p.coords.lng));
      });

      if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
        bounds.extend(new window.google.maps.LatLng(bounds.getNorthEast().lat() + 0.01, bounds.getNorthEast().lng() + 0.01));
      }

      map.fitBounds(bounds);
      map.panToBounds(bounds);
      onMount(map, onMountProps);
    }
  }, [map, onMount, onMountProps]);

  return <div ref={ref} className={className} />;
}


function shouldNotUpdate(props, nextProps) {
  const [funcs, nextFuncs] = [functions(props), functions(nextProps)]
  const noPropChange = isEqual(omit(props, funcs), omit(nextProps, nextFuncs))
  const noFuncChange =
    funcs.length === nextFuncs.length &&
    funcs.every(fn => props[fn].toString() === nextProps[fn].toString())
  return noPropChange && noFuncChange
}


export default React.memo(Map, shouldNotUpdate)

// fix initial position (lat,long)
Map.defaultProps = {
  options: {
    center: { lat: parseFloat(process.env.REACT_APP_MAP_LAT), lng: parseFloat(process.env.REACT_APP_MAP_LNG) },
    zoom: 10,
    scrollwheel: true,
    id: 'map'
  },
}